import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import PagesStore from '@Store/Pages'
import { pixel_logo, site_url } from '@root/shared_config.js';

export default function SetTitleAndMetas ()
{
	const { pathname } = useLocation();

	const pages_infos = PagesStore.useState(function(store)
	{
		return store.pages.map(function(path, i)
		{
			return { path: path, metas: store.metas[i] };
		})
		.filter(infos => !infos.path.includes('['));
	});

	useEffect(function ()
	{
		const page = pages_infos.find(infos => infos.path === (pathname || '/'));

		const link_canonical = document.querySelector('link[rel="canonical"');

		const url = site_url + pathname;

		link_canonical.setAttribute('href', url);

		if (!page?.metas?.title) return;

		const title = document.getElementsByTagName('title')?.[0];

		if (!title) return;

		title.textContent = page.metas.title;

		const description = document.querySelector('meta[name="description"]');

		if (description)
		{
			description.setAttribute('content', page.metas.description || '');
		}

		if (!title) return;

		const open_graph_metas = 
		{
			title: page.metas.title,
			description: page.metas.description,
			image: page.metas.image ? page.metas.image : site_url + pixel_logo,
			type: "website",
			url: site_url + pathname
		};

		const html_open_graph_metas = Array
		.from(document.querySelectorAll('meta[property^="og:"]'));

		html_open_graph_metas.forEach(function (node)
		{
			const field = (node.getAttribute('property') || '').replace('og:', '');

			const value = open_graph_metas[field] || '';

			node.setAttribute('content', value);
		});
	},
	[pages_infos, pathname]);
}